module.exports = __webpack_public_path__ + "static/media/arrow-down-solid.f394b111.svg";